import apiSales from '../apiSales';

import { ParamsDataGetListarCotacoes } from 'utils/typeServices';

export const GetListarCotacoes = async (CPF_CNPJ: string) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiSales.get<Array<ParamsDataGetListarCotacoes>>(`/Quote/v2/ListarCotacoes?CPF_CNPJ=${CPF_CNPJ}&CD_SISTEMA=4&CD_SISTEMA=5`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
